import React from 'react';
import './index.css';
import Toast from '../common/Toast'
import util from "../../util/tools";

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            weixinurl: "",
            bookId: "",
            hongbao:'',
            coin:'',
            text:''
        };
    }

    componentDidMount() {
        document.title = '金币充值'
        this.setState({
            bookId: this.props.match.params.bookId,
            weixinurl: this.props.match.params.weixinurl
        },()=>{
            this.getUserInfo()
        })
    }

    getUserInfo(){
        util.ajax({
            url: "/zh/user/userInfo",
            isUser: true,
            data: {},
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data
                    this.setState({
                        coin:data.user_money.coin,
                        hongbao:data.user_money.hongbao
                    })
                }
            }
        });
    }

    showText(text){
        this.setState({
            text:text
        },()=>{
            setTimeout(()=>{
                this.setState({
                    text:"",
                })
            },2000)
        })
    }

    recharge(item,index){
        if(!item){return false;}
        let url = this.state.weixinurl || `${document.location.href}`;
        let mineUrl = document.location.origin + '/mine';
        let params = {
            'total_fee':item*100,
            'back_url':mineUrl,
            'error_url': url,
            'wuyi': 1
        }
        if(!!this.state.bookId){
            params.book_id = this.state.bookId
        }
        util.ajax({
            url: "/zh/pay/wgpay",
            method:'post',
            isUser: true,
            isWechatId: true,
            data: params,
            callback: res => {
                if (res.result.status.code == 0) {
                    document.location.href = res.result.data.url
                }else {
                    this.showText(res.result.status.msg);
                }
            }
        });
    }

    goRoute(){
        this.props.history.push('/balance')
    }

    render() {
        return (
            <div className='qingmingrecharge'>
                <div className='recharge'>
                    <div className='recharge_items'>
                        <div className='block'><img  src={require(`../../../common/images/wuyi_bg1.jpg`)} /></div>
                        {[15.1,35.1,51].map((item,index)=>{
                            return (
                                <a className={`btn block btn${index+1}`} onClick={()=>this.recharge(item,index)} key={`r${index}`}><img  src={require(`../../../common/images/wuyi_bg${(index+2)}.jpg`)} /></a>
                            )
                        })}
                        <div className='block'><img  src={require(`../../../common/images/wuyi_bg5.jpg`)} /></div>
                    </div>
                </div>
                <Toast text={this.state.text}/>
            </div>
        );
    }
}